module.exports = __webpack_public_path__ + "static/media/result_fb_id.833ec902.jpg";